'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V($thiz) {
  if (($thiz.iP === (-1))) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalStateException__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalStateException());
  }
}
export { $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V as $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V };
function $ct_ju_AbstractRandomAccessListIterator__I__I__I__($thiz, i, start, end) {
  $thiz.hJ = i;
  $thiz.s8 = end;
  $thiz.iP = (-1);
  return $thiz;
}
export { $ct_ju_AbstractRandomAccessListIterator__I__I__I__ as $ct_ju_AbstractRandomAccessListIterator__I__I__I__ };
/** @constructor */
function $c_ju_AbstractRandomAccessListIterator() {
  this.hJ = 0;
  this.s8 = 0;
  this.iP = 0;
}
export { $c_ju_AbstractRandomAccessListIterator as $c_ju_AbstractRandomAccessListIterator };
$p = $c_ju_AbstractRandomAccessListIterator.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_AbstractRandomAccessListIterator;
/** @constructor */
function $h_ju_AbstractRandomAccessListIterator() {
}
export { $h_ju_AbstractRandomAccessListIterator as $h_ju_AbstractRandomAccessListIterator };
$h_ju_AbstractRandomAccessListIterator.prototype = $p;
$p.i = (function() {
  return (this.hJ < this.s8);
});
$p.e = (function() {
  if ((!this.i())) {
    throw $j_java$002elang$002e$002dObject.$ct_ju_NoSuchElementException__(new $j_java$002elang$002e$002dObject.$c_ju_NoSuchElementException());
  }
  this.iP = this.hJ;
  this.hJ = ((1 + this.hJ) | 0);
  return this.fS(this.iP);
});
$p.rg = (function() {
  $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V(this);
  this.WR(this.iP);
  if ((this.iP < this.hJ)) {
    this.hJ = ((this.hJ - 1) | 0);
  }
  this.iP = (-1);
  this.s8 = ((this.s8 - 1) | 0);
});
